module.exports = __webpack_public_path__ + "img/icon.1619e5fb.png";